"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.goal.efficiency': 'Eficiencia',
    'slot.goal.accuracy': 'Precisión',
    'slot.goal.creativity': 'Creatividad',
    'slot.goal.detail': 'Detalle',
};
